var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43886_81335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 2.625H17.625V15.375H9V2.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.625 15.75H10.125C9.91772 15.75 9.75 15.5823 9.75 15.375C9.75 15.1677 9.91772 15 10.125 15H17.25V3H10.125C9.91772 3 9.75 2.83228 9.75 2.625C9.75 2.41772 9.91772 2.25 10.125 2.25H17.625C17.8323 2.25 18 2.41772 18 2.625V15.375C18 15.5823 17.8323 15.75 17.625 15.75Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0L0 1.95652V16.0435L10.5 18V0Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M0 1.95653V2.14403L10.5 0.1875V0L0 1.95653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 3.75H12.75V5.25H9.75V3.75Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.75H16.5V5.25H13.5V3.75Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 6H12.75V7.5H9.75V6Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6H16.5V7.5H13.5V6Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 8.25H12.75V9.75H9.75V8.25Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.25H16.5V9.75H13.5V8.25Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10.5H12.75V12H9.75V10.5Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.5H16.5V12H13.5V10.5Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12.75H12.75V14.25H9.75V12.75Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.75H16.5V14.25H13.5V12.75Z",
    fill: "#177848"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 16.0435L10.5 18V17.8125L0 15.856V16.0435Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.625 15.75C17.8323 15.75 18 15.5823 18 15.375V9.75L10.5 2.25V15.75H17.625Z",
    fill: "url(#paint0_linear_43886_81335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51823 9.375L7.24144 6.27319L7.2197 6.26111L5.90971 6.35468L4.87498 8.21718L3.91922 6.49686L2.68188 6.58521L4.23174 9.375L2.68188 12.1648L3.91922 12.2531L4.87498 10.5328L5.90971 12.3953L7.2197 12.4889L7.24144 12.4768L5.51823 9.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M10.5 0L0 1.95652V16.0435L10.5 18V0Z",
    fill: "url(#paint1_linear_43886_81335)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.625 2.25H10.5V0L0 1.95653V16.0435L10.5 18V15.75H17.625C17.8323 15.75 18 15.5823 18 15.375V2.625C18 2.41772 17.8323 2.25 17.625 2.25Z",
    fill: "url(#paint2_linear_43886_81335)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_43886_81335",
    x1: 7.125,
    y1: 5.625,
    x2: 17.5155,
    y2: 16.0155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_43886_81335",
    x1: -0.099402,
    y1: 9.13807,
    x2: 10.419,
    y2: 9.13807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_43886_81335",
    x1: -1.17225,
    y1: 4.4715,
    x2: 18.7838,
    y2: 13.7767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43886_81335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/ExcelIcon.4a537c9568946b0f831aa0e7004fc73c.svg";
export { ForwardRef as ReactComponent };